import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/client.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Known Firestore SDK bug (v12.x): internal assertion on rapid listener churn.
// Self-heals; suppress the CRA dev overlay so it doesn't block the UI.
if (process.env.NODE_ENV === 'development') {
  const isFirestoreAssertion = (msg) =>
    typeof msg === 'string' &&
    msg.includes('FIRESTORE') &&
    msg.includes('INTERNAL ASSERTION FAILED');

  window.addEventListener('error', (event) => {
    if (isFirestoreAssertion(event.message)) {
      event.preventDefault();
      console.warn('[Firestore] Transient SDK assertion (recovered):', event.message);
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message || String(event.reason || '');
    if (isFirestoreAssertion(msg)) {
      event.preventDefault();
      console.warn('[Firestore] Transient SDK assertion (recovered):', msg);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
